import { Typography } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import OneTextArea from "../../../../../Components/OneTextArea/OneTextArea"
import { useContext, useEffect, useState } from "react"
import { WebSocketContext } from "../../../../../Providers/WebSocket/WebSocketContext"
import { showNotify } from "../../../../../Utils/Utils"
import OneModal from "../../../../../Components/OneModal/OneModal"
import { containerInfoEntregas, formGroupTextValue, formGroupTextValueSemDest, sessaoFotos, styleImg, textAreaSx } from "./InfoEntrega"

const InfoEntrega = ({ id_encomenda, setOpoenModalInfo, openModalInfo }) => {
    const { addRoute, sendWs } = useContext(WebSocketContext)
    const [encomenda, setEncomenda] = useState([])
    const [fotos, setFotos] = useState([])

    const BuscarEncomendasById = (msg) => {
        if (msg.data.status !== 'error') {
            let dado = msg.data.encomenda[0]

            if (msg.data.encomenda.length > 0) {
                let encomendaBase = {
                    morador: dado.morador,
                    origem: dado.origem,
                    tipo: dado.tipo,
                    unidade1: dado.unidade1,
                    unidade2: dado.unidade2
                }

                if (dado.encomenda_futura) {
                    setEncomenda({
                        ...encomendaBase,
                        palavra_chave: dado.palavra_chave,
                        observacao: dado.observacao,
                        encomenda_futura: dado.encomenda_futura
                    })
                } else {
                    setEncomenda({
                        ...encomendaBase,
                        status: dado.status,
                        codigo_rastreio: dado.codigo_rastreio,
                        observacao_recebedor: dado.observacao_recebedor
                    })

                    let stringBase64 = []

                    if (dado.anexos && dado.anexos.length > 0) {
                        dado.anexos.map((item) => {
                            if ((item.extensao == 'jpeg' || item.extensao == 'png' || item.extensao == 'jpg') && item.base64) {
                                stringBase64.push(`data:image/${item.extensao};base64,${item.base64}`)
                            }
                        })
                        setFotos(stringBase64)
                    }
                }
            }
        } else {
            showNotify('warning', 'Erro ao buscar informações da Encomenda')
            setOpoenModalInfo(false)
        }
    }
    addRoute("BuscarEncomendasById", BuscarEncomendasById)

    useEffect(() => {
        sendWs("BuscarEncomendasById", { id: id_encomenda })
    }, [])

    return (
        <OneModal
            open={openModalInfo}
            setOpen={setOpoenModalInfo}
            titleText={'Informações da Entrega'}
            fullWidth={true}
        >
            <Grid sx={containerInfoEntregas}>

                <Grid container xs={12} sm={12} md={12} lg={12} xl={12}>

                    <Grid xs={2} sm={2} md={2} lg={2} xl={2}>
                        <Typography>Nome:</Typography>
                    </Grid>

                    <Grid xs={10} sm={10} md={10} lg={10} xl={10}>
                        {
                            encomenda.morador
                                ? <Typography sx={formGroupTextValue}>{encomenda.morador}</Typography>
                                : <Typography sx={formGroupTextValueSemDest}>SEM DESTINATÁRIO</Typography>
                        }
                    </Grid>

                </Grid>

                <Grid container xs={12} sm={12} md={12} lg={12} xl={12}>

                    <Grid xs={2} sm={2} md={2} lg={2} xl={2}>
                        <Typography>Origem:</Typography>
                    </Grid>

                    <Grid xs={10} sm={10} md={10} lg={10} xl={10}>
                        <Typography sx={formGroupTextValue}>{encomenda.origem || '-'}</Typography>
                    </Grid>

                </Grid>
                {
                    typeof encomenda.status !== 'undefined' &&
                    <Grid container xs={12} sm={12} md={12} lg={12} xl={12}>

                        <Grid xs={2} sm={2} md={2} lg={2} xl={2}>
                            <Typography>status:</Typography>
                        </Grid>

                        <Grid xs={10} sm={10} md={10} lg={10} xl={10}>
                            <Typography sx={formGroupTextValue}>{encomenda.status == 0 ? 'A Retirar' : 'Entrege'}</Typography>
                        </Grid>

                    </Grid>
                }

                <Grid container xs={12} sm={12} md={12} lg={12} xl={12}>

                    <Grid xs={2} sm={2} md={2} lg={2} xl={2}>
                        <Typography>Tipo:</Typography>
                    </Grid>

                    <Grid xs={10} sm={10} md={10} lg={10} xl={10}>
                        <Typography sx={formGroupTextValue}>{encomenda.tipo || '-'}</Typography>
                    </Grid>

                </Grid>

                {
                    typeof encomenda.palavra_chave !== 'undefined' &&
                    <Grid container xs={12} sm={12} md={12} lg={12} xl={12}>

                        <Grid xs={2} sm={2} md={2} lg={2} xl={2}>
                            <Typography>Palavra chave:</Typography>
                        </Grid>

                        <Grid xs={10} sm={10} md={10} lg={10} xl={10}>
                            <Typography sx={formGroupTextValue}>{encomenda.palavra_chave || '-'}</Typography>
                        </Grid>

                    </Grid>
                }

                <Grid container xs={12} sm={12} md={12} lg={12} xl={12}>

                    <Grid xs={2} sm={2} md={2} lg={2} xl={2}>
                        <Typography>Imóvel:</Typography>
                    </Grid>

                    <Grid xs={10} sm={10} md={10} lg={10} xl={10}>
                        <Typography sx={formGroupTextValue}>{(encomenda.unidade1 || '') + '-' + (encomenda.unidade2 || '')}</Typography>
                    </Grid>

                </Grid>

                {
                    typeof encomenda.codigo_rastreio !== 'undefined' &&
                    <Grid container xs={12} sm={12} md={12} lg={12} xl={12}>

                        <Grid xs={5} sm={5} md={5} lg={5} xl={5}>
                            <Typography>Número do registro da encomenda:</Typography>
                        </Grid>

                        <Grid xs={6} sm={6} md={6} lg={6} xl={6}>
                            <Typography sx={formGroupTextValue}>{encomenda.codigo_rastreio || '-'}</Typography>
                        </Grid>

                    </Grid>
                }

                {
                    typeof encomenda.observacao !== 'undefined' &&
                    <Grid container xs={12} sm={12} md={12} lg={12} xl={12}>

                        <Grid xs={3} sm={3} md={3} lg={3} xl={3}>
                            <Typography>Observação Morador:</Typography>
                        </Grid>

                        <Grid xs={9} sm={9} md={9} lg={9} xl={9}>
                            <OneTextArea
                                defaultValue={encomenda.observacao}
                                readOnly={true}
                                name='observacao'
                                newSx={textAreaSx}
                            />
                        </Grid>

                    </Grid>
                }

                {
                    typeof encomenda.observacao_recebedor !== 'undefined' &&
                    <Grid container xs={12} sm={12} md={12} lg={12} xl={12}>

                        <Grid xs={2} sm={2} md={2} lg={3} xl={2}>
                            <Typography>Observação Recebedor:</Typography>
                        </Grid>

                        <Grid xs={10} sm={10} md={10} lg={9} xl={10}>
                            <OneTextArea
                                name="observacoes"
                                defaultValue={encomenda.observacao_recebedor}
                                readOnly={true}
                                newSx={textAreaSx}
                            ></OneTextArea>
                        </Grid>

                    </Grid>
                }

                {
                    typeof encomenda.encomenda_futura == 'undefined' &&
                    <Grid container xs={12} sm={12} md={12} lg={12} xl={12}>

                        <Grid xs={2} sm={2} md={2} lg={2} xl={2}>
                            <Typography>Fotos:</Typography>
                        </Grid>

                        <Grid xs={10} sm={10} md={10} lg={10} xl={10} sx={sessaoFotos}>
                            {
                                fotos && fotos.length > 0
                                    ? fotos.map((foto, index) => (
                                        <img key={index} src={foto} style={styleImg} />
                                    ))
                                    : 'Sem Fotos'
                            }
                        </Grid>

                    </Grid>
                }

            </Grid>
        </OneModal>

    )
}

export default InfoEntrega
